import { Models } from '@ibexfusion/models';
import { DataProvider, DataProviderResponse } from '../data-provider';
import * as _ from 'lodash';

export class MemoryService<T extends Models.IbexBaseModel> implements DataProvider<T> {

  constructor(data: T[] = []) {
    this.db = data;
  }

  private _db: T[];

  public get db(): T[] {
    return this._db;
  }

  public set db(value: T[]) {
    this._db = value;
  }

  public find(skip: number, limit: number, params?: any): Promise<DataProviderResponse<T>> {
    let tempData = this.db;
    if (params && Object.keys(params).length > 0) {
      tempData = _.filter(tempData, element => {
        let result = true;
        for (const filter of Object.keys(params)) {
          if (params[filter].$regex) {
            const regex = new RegExp(params[filter].$regex, params[filter].$options);
            if (!regex.test(element[filter])) {
              result = false;
            }
          }
        }
        return result;
      });
    }
    // TODO: Implement param search functionality
    const newData: T[] = tempData.slice(skip, skip + limit);

    const response: DataProviderResponse<T> = {
      data: newData,
      limit: limit,
      skip: skip,
      total: tempData.length
    };

    return Promise.resolve(response);
  }

  public get(index: number): Promise<T> {
    return Promise.resolve(this._db[index]);
  }

  public remove(index: number): Promise<boolean> {
    this._db.splice(index, 1);
    return Promise.resolve(true);
  }

  public create(data: T): Promise<T> {
    this._db.push(data);
    return Promise.resolve(data);
  }

  public update(index: number, data: T): Promise<T> {
    this._db[index] = data;
    return Promise.resolve(data);
  }

}
